import {createContext, ReactNode, useContext} from 'react';

export type VisualViewportSnapshot = {
  offsetLeft: number;
  offsetTop: number;
  pageLeft: number;
  pageTop: number;
  width: number;
  height: number;
  scale: number;
};

const ParentViewportContext = createContext<VisualViewportSnapshot | undefined>(
  undefined,
);

export function ParentViewportProvider({
  children,
  value,
}: {
  children: ReactNode;
  value?: VisualViewportSnapshot;
}) {
  return (
    <ParentViewportContext.Provider value={value}>
      {children}
    </ParentViewportContext.Provider>
  );
}

export function useParentViewportSnapshot() {
  return useContext(ParentViewportContext);
}
